import { combineReducers } from "redux";
import customizer from "./customizer/";
import auth from "./auth/";
import navbar from "./navbar/Index";
import customerDataListReducer from "./customer/";
import PartnerDataListReducer from "./partner/";
import UserDataListReducer from "./user/";
import ExportConfigDataListReducer from "./exportConfig";
import ImportConfigDataListReducer from "./importConfig";
import AdminstrationLogReducer from "./adminstrationLog";
import ChatbotDataListReducer from "./askeleieSetup";
import ChatbotActionListReducer from "./chatbotActions";
import ChatbotEntityListReducer from "./chatbotEntity";
import ChatbotIntentListReducer from "./chatbotIntent";
import ChatbotStoryListReducer from "./chatbotStory";
import ChatbotSlotListReducer from "./chatbotSlot";
import ChatbotSlotValidationListReducer from "./chatbotSlotValidation";
import ChatbotFormListReducer from "./chatbotForm";
import WaivesReducer from "./waives";
import KnowledgeBaseReducer from "./knowledgeBase";
import ModelConfigReducer from "./extractionModel";
import OrganisationReducer from "./organisation";
import ApiKeyReducer from "./apiKeyManagement";
import UserManagementReducer from "./userManagement";
import GroupsReducer from "../workbench-redux/reducers/groups";
import DocumentsReducer from "../workbench-redux/reducers/documents";
import BrandingReducer from "./branding";

import SearchDataListReducer from "./common";
import DocumentExtractionReducer from "./documentExtractionSetup";
import SmartClassesReducer from "./smartClasses";
import SmartQueueReducer from "./smart-queue";
import SubscriptionManagerReducer from "./subscriptionManager";
import HistoryReducer from "./history";
import OrchestratorServerReducer from "./orchestratorServer";
import ImportConnectorReducer from './importConnector'
import ExportConnectorReducer from "./exportConnector";

const appReducer = combineReducers({
  customizer: customizer,
  auth: auth,
  navbar: navbar,
  customerDataListReducer: customerDataListReducer,
  exportConfigDataListReducer: ExportConfigDataListReducer,
  importConfigDataListReducer: ImportConfigDataListReducer,
  partnerDataListReducer: PartnerDataListReducer,
  userDataListReducer: UserDataListReducer,
  userManagementReducer: UserManagementReducer,
  adminstrationLogReducer: AdminstrationLogReducer,
  chatbotDataListReducer: ChatbotDataListReducer,
  chatbotActionListReducer: ChatbotActionListReducer,
  chatbotEntityListReducer: ChatbotEntityListReducer,
  chatbotIntentListReducer: ChatbotIntentListReducer,
  chatbotStoryListReducer: ChatbotStoryListReducer,
  chatbotSlotListReducer: ChatbotSlotListReducer,
  chatbotSlotValidationListReducer: ChatbotSlotValidationListReducer,
  chatbotFormListReducer: ChatbotFormListReducer,
  waivesReducer: WaivesReducer,
  knowledgeBaseReducer: KnowledgeBaseReducer,
  modelConfigReducer: ModelConfigReducer,
  organisationReducer: OrganisationReducer,
  apiKeyReducer: ApiKeyReducer,

  groups: GroupsReducer,
  documents: DocumentsReducer,
  searchDataListReducer: SearchDataListReducer,
  documentExtractionReducer: DocumentExtractionReducer,
  smartClassesReducer: SmartClassesReducer,
  smartQueueReducer: SmartQueueReducer,
  subscriptionManagerReducer: SubscriptionManagerReducer,
  historyReducer: HistoryReducer,
  brandingReducer: BrandingReducer,
  orchestratorServerReducer: OrchestratorServerReducer,
  importConnectorReducer: ImportConnectorReducer,
  exportConnectorReducer: ExportConnectorReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
